export const BREAKPOINTS = {
  MOBILE: 600,
  DESKTOP_SM: 768,
  MOBILE_MENU: 810,
  DESKTOP_MD: 1024,
  DESKTOP_LG: 1680,
} as const;
